/*
  BDEK cart add-ons (snippets/bdek-cart-extras.liquid), in the cart drawer and cart page.
  "Add" puts that add-on in the cart (with the pre-order note when it's a pre-order size),
  then asks Impulse to rebuild the cart ("cart:build").
*/
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-bdek-addon-add]');
    if (!button) return;
    var row = button.closest('[data-bdek-addon]');
    var box = button.closest('.bdek-cart-addons');
    var status = box && box.querySelector('[data-bdek-addon-status]');
    var field = row && row.querySelector('[data-bdek-addon-variant]');
    if (!field) return;

    var id = field.value;
    var preorder = field.getAttribute('data-preorder');
    if (field.tagName === 'SELECT') {
      if (!id) {
        field.setAttribute('aria-invalid', 'true');
        if (status) status.textContent = status.getAttribute('data-choose');
        field.focus();
        return;
      }
      preorder = field.options[field.selectedIndex].getAttribute('data-preorder');
    }

    var item = { id: Number(id), quantity: 1 };
    if (preorder) {
      item.properties = {};
      item.properties[box.getAttribute('data-preorder-label') || 'Pre-order'] = preorder;
    }

    button.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart');
          return data;
        });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function (error) {
        if (status) status.textContent = error.message;
        button.disabled = false;
      });
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-bdek-addon-variant]')) event.target.removeAttribute('aria-invalid');
  });
})();
